import { AfterViewInit, Component, Input } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { ButtonComponent } from '../core/buttons/button.component';
import { ActionRowComponent } from '../core/panels/action-row.component';

@Component({
  selector: 'app-timeout-dialog',
  template: `
    <div class="app-pb2 app-pt3">
      <div>
        <strong>
          You will be logged out in
          <span id="minutes" class="tw-text-[var(--sed-status-red-color)]">{{
            minutes
          }}</span>
          minutes and
          <span id="seconds" class="tw-text-[var(--sed-status-red-color)]">{{
            seconds
          }}</span>
          seconds.
        </strong>
        <br />
        {{ message }}
        <div class="tw-pb-8"></div>
      </div>
      <app-action-row>
        @if (inactivityDialog) {
          <app-button
            icon="fa-check fa-light"
            (click)="doUpdateActivity()"
            right1
            label="OK"
            labelCase="none"
          />
        } @else {
          <app-button
            icon="fa-check fa-light"
            (click)="sessionLifetimeOkPressed()"
            right1
            label="OK"
            labelCase="none"
          />
        }
        @if (inactivityDialog) {
          <app-button right2 emphasis="Low" (click)="logout()" label="Logout" />
        }
      </app-action-row>
    </div>
  `,
  styles: [``],
  imports: [ActionRowComponent, ButtonComponent],
})
export class TimeoutDialogComponent
  extends BaseComponent
  implements AfterViewInit
{
  @Input() countFrom: number;
  @Input() message: string;
  @Input() inactivityDialog = false;
  @Input() minutes: string;
  @Input() seconds: string;

  private deadline: number;

  ngAfterViewInit(): void {
    this.deadline = Date.now() + this.countFrom * 1000;
    this.startTimer();
  }

  public doUpdateActivity() {
    this.session.updateActivity.emit(true);
  }

  public sessionLifetimeOkPressed() {
    this.session.sessionLifetimeOkPressed.emit(true);
  }

  public async logout() {
    this.session.updateActivity.emit(false);
  }

  startTimer() {
    let expiredEmitted = false;
    this.dispose.intervals = setInterval(() => {
      const remaining = Math.max(
        0,
        Math.floor((this.deadline - Date.now()) / 1000),
      );
      this.minutes = Math.floor(remaining / 60).toString();
      this.seconds = (remaining % 60).toString().padStart(2, '0');

      if (remaining <= 0 && !expiredEmitted) {
        expiredEmitted = true;
        if (this.inactivityDialog) {
          this.session.sessionExpiredLogout.emit();
        } else {
          this.session.maxSessionExpired.emit();
        }
      }
    }, 1000);
  }
}
